export default {
  'forms.validation.enter_valid_url': 'Please enter a valid URL',
  'forms.validation.enter_api_base_url': 'Please enter an API Base URL',
  'forms.validation.enter_status_check_name':
    'Please enter a name for this Health Check',
  'forms.validation.enter_monitor_url': 'Please enter a Monitor URL',
  'forms.validation.error.invalid_url': 'URL is not valid',
  'forms.validation.error.empty_status_check_name':
    'Health Check name cannot be empty',
  'forms.validation.error.monitor_url_already_exists':
    'Health Check URL is already configured for the selected Observability Tool',
  'forms.validation.error.invalid_request_timeout':
    'Request timeout must be between 50 and 5000',
  'forms.validation.enter_aws_account_id': 'Please enter an AWS Account ID',
  'forms.validation.enter_aws_account_id.error.already_in_use':
    'Account ID already in use',
  'forms.validation.enter_aws_account_id.error.length':
    'Please enter a valid AWS Account ID (must be exactly 12 digits long)',
  'forms.validation.active_days.required':
    'At least one active day must be selected',
  'forms.validation.start_time_required': 'Start time is required',
  'forms.validation.end_time_range':
    'End time must be between {{minimum}} and {{maximum}} hours after start time'
}
